import { TableColumnsType } from 'antd';
import { AssistantTableData } from './types';

export const PAGE_SIZE = 9;

export const STATUS_FILTERS = ['All', 'Active', 'Inactive'];

export const CHANNEL_OPTIONS = [
  { value: 'All', label: 'Channel: All', iconName: null },
  { value: 'whatsapp', label: 'WhatsApp', iconName: 'whatsapp' },
  { value: 'voice', label: 'Voice', iconName: 'phone' },
  { value: 'email', label: 'Email', iconName: 'mail' },
  { value: 'web', label: 'Web', iconName: 'global' },
];

export const DEFAULT_APPEARANCE_STATE = {
  primaryColor: '#E3F571',
  backgroundColor: '#ffffff',
  textColor: '#000000',
  buttonColor: '#E3F571',
  backgroundMessageColor: '#f0f2f5',
  colorTitleText: '#7E70B3', // This maps to Secondary Color (colorMain)
  iconColor: '#000000',
  greetingMessage: 'Hello! How can I help you today?'
};

export const columns: TableColumnsType<AssistantTableData> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Active State',
      dataIndex: 'activeState',
      key: 'activeState',
    },
    {
      title: 'Schedule',
      dataIndex: 'schedule',
      key: 'schedule',
    },
    {
      title: '',
      key: 'manageSchedule',
    },
    {
      title: 'Last Sync',
      dataIndex: 'lastSync',
      key: 'lastSync',
    },
    {
      title: 'Action',
      key: 'action',
    },
]; 